module.exports = __webpack_public_path__ + "static/img/banner2.f074faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/banner2.png
// module id = I1yX
// module chunks = 0